<template>
  <div class="header">
    <div class="header_progression">
      <div class="header_etape" v-for="(titre, index) in titres" :class="estActif(index + 1)" :key="index">
        <div class="header_etape_numero">0{{ index + 1 }}</div>
        <div class="header_etape_nom">{{ titre }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progression',
  props: ['courant'],
  data() {
    return {
      titres: [
        'Votre projet',
        'Votre expérience',
        'Votre profil',
        'Votre financement'
      ]
    }
  },
  methods: {
    estActif(index) {
      if (index < parseInt(this.courant, 10)) {
        return 'barre_progression_principale active';
      } else if (index === parseInt(this.courant, 10)) {
        return 'barre_progression_principale active courante';
      } else {
        return 'barre_progression_principale';
      }
    }
  }
}
</script>

<style scoped>
.header {
  border-bottom: solid 1px lightgrey;
  padding-bottom: 5px;
}

.header_progression {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

@media (min-width: 932px) {
  .header_progression {
    width: 70%;
  }
}

.header_etape {
  margin-left: 0;
  margin-right: 1em;
}

.header_etape:last-child {
  margin-right: 0;
}

.header_etape_nom {
  font-weight: bold;
}

.barre_progression_principale {
  color: #002e5d;
  opacity: .5;
}

.barre_progression_principale.active {
  color: #002e5d;
  opacity: 1;
}

.barre_progression_principale.active.courante {
  position: relative;
  margin-bottom: .7rem;
}

.barre_progression_principale.active.courante:after {
  background-color: #c4d600;
  bottom: -1rem;
  content: '';
  display: inline-block;
  height: 0.3125rem;
  left: 0;
  position: absolute;
  vertical-align: top;
  width: 2.8125rem;
}
</style>